// src/components/home/TestimonialsSection.jsx
import React from 'react';
import styles from './TestimonialsSection.module.css';

const allTestimonials = [
  {
    id: 1,
    text: "Bspark transformed my career path! The practical knowledge and placement support were exceptional.",
    author: "Sarah J.",
    role: "Software Developer",
    rating: 5,
    source: "Google"
  },
  {
    id: 2,
    text: "From a beginner to a confident Data Scientist, Bspark's trainers guided me every step of the way.",
    author: "Raj K.",
    role: "Data Analyst",
    rating: 5,
    source: "Google"
  },
  {
    id: 3,
    text: "The coding world seemed daunting, but Bspark made it accessible and fun. The interactive teaching style is fantastic!",
    author: "Jovin S.",
    role: "Web Developer",
    rating: 5,
    source: "Whatsapp"
  },
  {
    id: 4,
    text: "The support from the mentors was outstanding. They genuinely care about your success.",
    author: "Preethi L.",
    role: "Project Manager",
    rating: 5,
    source: "Google"
  },
  {
    id: 5,
    text: "I landed my dream job thanks to Bspark's comprehensive curriculum and mock interviews.",
    author: "Mohammad A.",
    role: "QA Engineer",
    rating: 5,
    source: "Google"
  },
  {
    id: 6,
    text: "Their corporate training module was a game-changer for our team. Highly recommended!",
    author: "Anitha M.",
    role: "Tech Lead",
    rating: 5,
    source: "Google"
  },
  {
    id: 7,
    text: "The personalized attention helped me master complex concepts with ease.",
    author: "Vishal P.",
    role: "DevOps Engineer",
    rating: 5,
    source: "Google"
  },
  {
    id: 8,
    text: "Excellent course material and a very supportive learning environment. I am so glad I chose Bspark.",
    author: "Priya V.",
    role: "UI/UX Designer",
    rating: 5,
    source: "Whatsapp"
  },
  {
    id: 9,
    text: "Bspark provided the perfect blend of theory and hands-on projects, which was crucial for my growth.",
    author: "Karthik R.",
    role: "Full Stack Developer",
    rating: 5,
    source: "Google"
  },
  {
    id: 10,
    text: "The mock interviews were incredibly helpful and boosted my confidence for the job market.",
    author: "Sai E.",
    role: "Software Engineer",
    rating: 5,
    source: "Google"
  },
  {
    id: 11,
    text: "A fantastic place to start your career in technology. The trainers are top-notch!",
    author: "Divya N.",
    role: "Frontend Developer",
    rating: 5,
    source: "Google"
  },
  {
    id: 12,
    text: "The flexibility of the courses allowed me to learn while working. Highly recommended for working professionals.",
    author: "Sunil K.",
    role: "Cloud Architect",
    rating: 5,
    source: "Google"
  },
];

const testimonialsColumn1 = allTestimonials.slice(0, 4);
const testimonialsColumn2 = allTestimonials.slice(4, 8);
const testimonialsColumn3 = allTestimonials.slice(8, 12);

const TestimonialsSection = () => {
  const renderTestimonials = (testimonialsArray) => (
    <>
      {testimonialsArray.map((testimonial, index) => (
        <div key={testimonial.id} className={styles.testimonialCard}>
         
          <p className={styles.testimonialText}>"{testimonial.text}"</p>
          <div>
              <div className={styles.authorInfo}>
             <div className={styles.rating}>
            {Array(testimonial.rating).fill().map((_, i) => (
              <span key={i}>&#9733;</span>
            ))}
          </div>
          <div>
               <span className={styles.authorName}>{testimonial.author}</span>
            <span className={styles.authorRole}>{testimonial.role}</span>
          </div>
          </div>
        
         
          </div>
        </div>
      ))}
    </>
  );

  return (
    <section className={styles.testimonialsSection}>
      <h2 className={styles.sectionHeading}>Hear From Our Success Stories</h2>
      <p className={styles.sectionSubtitle}>
        Our students' achievements speak volumes about the quality of our training.
      </p>

      <div className={styles.carouselContainer}>
        {/* Column 1: Scrolls up */}
        <div className={styles.testimonialColumn}>
          <div className={`${styles.testimonialsTrack} ${styles.scrollUp}`}>
            {renderTestimonials([...testimonialsColumn1, ...testimonialsColumn1])}
          </div>
        </div>

        {/* Column 2: Scrolls down */}
        <div className={styles.testimonialColumn}>
          <div className={`${styles.testimonialsTrack} ${styles.scrollDown}`}>
            {renderTestimonials([...testimonialsColumn2, ...testimonialsColumn2])}
          </div>
        </div>

        {/* Column 3: Scrolls up */}
        <div className={styles.testimonialColumn}>
          <div className={`${styles.testimonialsTrack} ${styles.scrollUp}`}>
            {renderTestimonials([...testimonialsColumn3, ...testimonialsColumn3])}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;